import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import {
  Col, Row, Container, InputGroup, InputGroupAddon,
  InputGroupText, Input, Form, FormGroup, Label, Button
} from 'reactstrap';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { LoginRequest } from '../../../redux/Action/Login';
import { Field, reduxForm } from 'redux-form'
import LoadingBar, { showLoading } from 'react-redux-loading-bar'
import logo from "../../../assets/images/Layer.png"
import validate from './validation';
import { Redirect } from 'react-router-dom';
import './Login.css'

const renderField = ({ label, placeholder, input, type, icone, meta: { touched, error, warning } }) => (
  <div>
    <Label>{label}</Label>
    <InputGroup>
      <Input {...input} placeholder={placeholder} type={type} />
      <InputGroupAddon addonType="prepend">
        <InputGroupText>
          <i className={icone}></i>
        </InputGroupText>
      </InputGroupAddon>
    </InputGroup >
    <div style={{ textAlign: 'right', marginTop: "10px" }}>
      {touched && ((error && <span className="mt-3 erroMSG" style={{ color: "red", fontSize: "0.8rem" }}> {error}</span>))}
    </div>
  </div>
)

class Login extends Component {

  constructor() {
    super();
    this.state = {
      selectedOption: 'admin'
    };
    this.radioChange = this.radioChange.bind(this);
  }

  radioChange(e) {
    this.setState({
      selectedOption: e.currentTarget.value
    });
  }

  onSubmit = (values) => {
    this.props.showLoading();
    values.type = this.state.selectedOption === "admin" ? "ADMIN" : "SUB_ADMIN"
    this.props.LoginRequest(values)
    console.log("this.state.selectedOption", values.type)
  }

  goToForgetPassword() {
    return (
      <Link to={{ pathname: `/Maktapti/forgetPassword` }} id="forgetpasswordd" style={{
        color: '#0f689f', fontSize: '18px'
      }}>
        هل نسيت كلمة المرور
      </Link>
    )
  }

  render() {
    if (this.props.token) {
      return (
        <Redirect to="/Maktapti/Dashboard" />
      )
    }
    const { handleSubmit, submitting } = this.props
    return (
      <div>
        <div className="loading-bar" >
          <LoadingBar style={{ height: '3px', zIndex: 1000, backgroundColor: "orange" }} />
        </div>

        <div className="AllLoginView">
          <Container>
            <Row>
              <Col lg="6" style={{ backgroundColor: "#333", borderRadius: "7px 0 0 7px" }}>
                <div className="leftSide-login-Logo">
                  {/* <a href="http://newconcept-group.com/" style={{ height: "100%" }}> */}
                  <img src={logo} alt="brand-logo" />
                  {/* </a> */}
                </div>
              </Col>
              <Col lg="6">
                <div>
                  <h2 className="pt-4 pb-2">
                    <span style={{ color: '#0095da' }}> تسجيل </span>
                    <span style={{ color: '#fbb03b' }}>الدخول </span>
                  </h2>
                  <Form onSubmit={handleSubmit(this.onSubmit.bind(this))} style={{ direction: "rtl" }}>
                    <FormGroup>
                      <Field type="email" name="email" component={renderField} label="البريد الالكتروني" placeholder="Tech4Life@gmail.com" icone="fa fa-envelope-open" />
                    </FormGroup>
                    <FormGroup>
                      <Field type="password" label="كلمة المرور" placeholder="**********" name="password" component={renderField} icone="fa fa-lock" />
                    </FormGroup>
                    <Row className="LoginType">
                      <Col lg="12">
                        <h4>نوع المستخدم</h4>
                      </Col>
                      <Col>
                        <FormGroup>
                          <input type="radio" id="admin" name="typelogin" value="admin" checked={this.state.selectedOption === "admin"}
                            onChange={this.radioChange} />
                          <label className="mr-3" style={{ color: "rgb(15, 104, 159)" }}>ادمن</label>
                        </FormGroup>
                      </Col>
                      <Col>
                        <FormGroup>
                          <input type="radio" id="subadmin" name="typelogin" value="subadmin" checked={this.state.selectedOption === "subadmin"}
                            onChange={this.radioChange} />
                          <label className="mr-3" style={{ color: "rgb(15, 104, 159)" }}>مسئول</label>
                        </FormGroup>
                      </Col>
                    </Row>
                    {/* <h3>this.state.selectedOption: {this.state.selectedOption}</h3> */}
                    <Button type="submit" className="btn btn-block" disabled={submitting}>تسجيل الدخول</Button>
                  </Form>
                  <div className="pb-4 pt-3">
                    {this.goToForgetPassword()}
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </div>
    )
  }
}
const mapStateToProps = state => {
  return {
    token: state.login.token,
  }
}
const mapDispatchToProps = dispatch => bindActionCreators(
  {
    LoginRequest,
    showLoading,
  }
  , dispatch
)

export default reduxForm({
  form: 'fieldLevelValidation',
  validate
})(connect(mapStateToProps, mapDispatchToProps)(Login));